var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComplaintWasteManagementComplaints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1908_26833)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 50,
    height: 50,
    rx: 12,
    fill: "url(#paint0_linear_1908_26833)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1908_26833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.3838 29.2307C52.3968 29.3259 52.3894 29.4228 52.362 29.515C52.3346 29.6071 52.2879 29.6923 52.2249 29.765C52.162 29.8376 52.0842 29.896 51.9969 29.9362C51.9096 29.9764 51.8148 29.9976 51.7186 29.9982L34.2734 29.8528C34.1742 29.8515 34.0764 29.8284 33.9871 29.7852C33.8978 29.7419 33.8191 29.6795 33.7567 29.6023C33.6942 29.5252 33.6495 29.4353 33.6257 29.339C33.6019 29.2426 33.5996 29.1422 33.619 29.0449C33.7714 28.226 34.183 27.4777 34.7929 26.9104C35.4029 26.3431 36.179 25.9868 37.0068 25.8941C37.0073 24.8744 37.4074 23.8956 38.1213 23.1676C38.8352 22.4396 39.806 22.0204 40.8255 22C41.7511 22.0001 42.6433 22.3458 43.3273 22.9695C44.01 22.3456 44.9015 21.9997 45.8264 22C46.8571 22.0205 47.8376 22.4486 48.5534 23.1906C49.2691 23.9326 49.6616 24.9279 49.645 25.9587V26.026C50.36 26.2428 50.9979 26.6598 51.4833 27.2277C51.9686 27.7956 52.2811 28.4907 52.3838 29.2307ZM55.4754 29.158L54.3093 24.7576C54.2717 24.6137 54.1872 24.4863 54.0692 24.3956C53.9512 24.3049 53.8064 24.2561 53.6576 24.2567H50.7169C50.8081 24.5309 50.8774 24.8118 50.9242 25.0969C51.6673 25.4853 52.3077 26.0444 52.7927 26.7284C53.2777 27.4124 53.5935 28.2017 53.7142 29.0314C53.763 29.3583 53.7306 29.6922 53.6199 30.0036H54.8237C54.9283 30.004 55.0315 29.9799 55.125 29.9331C55.2186 29.8863 55.2999 29.8182 55.3623 29.7343C55.4229 29.6527 55.4645 29.5587 55.4841 29.459C55.5037 29.3592 55.5007 29.2564 55.4754 29.158ZM32.2967 28.7917C32.4758 27.8753 32.8939 27.0225 33.5087 26.3198C34.1235 25.617 34.9132 25.0892 35.7976 24.7899C35.8383 24.6078 35.8886 24.4281 35.9485 24.2513H32.3398C32.1903 24.251 32.045 24.3006 31.9269 24.3924C31.8088 24.4841 31.7248 24.6127 31.6881 24.7576L30.5221 29.158C30.4983 29.256 30.4967 29.358 30.5171 29.4568C30.5376 29.5555 30.5798 29.6484 30.6406 29.7289C30.703 29.8128 30.7842 29.8809 30.8778 29.9277C30.9713 29.9745 31.0746 29.9986 31.1792 29.9982H32.4422C32.2715 29.6204 32.2207 29.1993 32.2967 28.7917ZM52.6666 31.3447L51.347 51.3698C51.336 51.5408 51.2603 51.7012 51.1352 51.8183C51.0101 51.9354 50.8451 52.0003 50.6738 52H35.3237C35.1523 52.0003 34.9873 51.9354 34.8622 51.8183C34.7371 51.7012 34.6614 51.5408 34.6504 51.3698L33.3309 31.3447H52.6666ZM42.2501 37.8375L41.3479 39.9623L42.5894 40.5009L44.0113 37.1481C44.0766 36.9985 44.0852 36.8302 44.0357 36.6747C43.9861 36.5191 43.8818 36.3869 43.742 36.3025L40.575 34.4524L39.8964 35.6158L41.5984 36.6122C40.4861 36.9186 39.5051 37.5813 38.8056 38.4987C38.1061 39.4161 37.7268 40.5376 37.7258 41.6912H39.0723C39.074 40.7803 39.3917 39.8982 39.9712 39.1954C40.5508 38.4926 41.3562 38.0127 42.2501 37.8375ZM48.2716 41.6912H46.9251C46.9244 42.6626 46.5641 43.5994 45.9137 44.3209C45.2633 45.0424 44.3688 45.4976 43.4027 45.5987L44.3452 43.3824L43.1064 42.8438L41.6791 46.2127C41.6146 46.3621 41.6064 46.5297 41.6559 46.6847C41.7054 46.8396 41.8093 46.9714 41.9485 47.0557L45.0966 48.895L45.7752 47.7316L44.2079 46.816C45.3629 46.5434 46.3923 45.8892 47.1297 44.9593C47.8671 44.0294 48.2694 42.878 48.2716 41.6912Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1908_26833",
    x: 0,
    y: 0,
    width: 90,
    height: 90,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.439216 0 0 0 0 0.564706 0 0 0 0 0.690196 0 0 0 0.64 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1908_26833"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1908_26833",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1908_26833",
    x: 24.5029,
    y: 20,
    width: 36.9941,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.32 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1908_26833"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1908_26833",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1908_26833",
    x1: 43,
    y1: 12,
    x2: 43,
    y2: 62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2B4F78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B325F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplaintWasteManagementComplaints);
export default __webpack_public_path__ + "static/media/ComplaintWasteManagementComplaints.06e05a6f38ef4f26be9b195c4bce3a3f.svg";
export { ForwardRef as ReactComponent };